import React from "react";
import styled from "styled-components";

interface LinkProps extends React.ComponentProps<any> {
  link?: string;
  text: string;
  linkStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  subtitle?: string;
  subtitleStyle?: React.CSSProperties;
  target?: string;
  ariaLabel?: string;
}

const Link = ({
  text,
  link,
  linkStyle = {},
  textStyle = {},
  subtitle,
  subtitleStyle = {},
  onClick,
  target,
  ariaLabel,
}: LinkProps) => {
  const content = (
    <>
      <Title style={textStyle}>{text}</Title>
      {subtitle && <Subtitle style={subtitleStyle}>{subtitle}</Subtitle>}
    </>
  );

  // Se c'è una destinazione è un link: <a href>. Altrimenti è un'azione: <button>.
  // Un <a> senza href non è focusabile e non risponde a Invio (WCAG 2.1.1).
  if (link) {
    return (
      <StyledLink
        as="a"
        href={link}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        style={linkStyle}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {content}
      </StyledLink>
    );
  }

  return (
    <StyledLink
      as="button"
      type="button"
      style={linkStyle}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {content}
    </StyledLink>
  );
};

const StyledLink = styled.span`
  :hover {
    box-shadow: 0 3px 18px 0 rgb(45 46 46 / 15%);
  }
  cursor: pointer;
  min-width: 18rem;
  min-height: 4.6rem;
  font-weight: 700;
  font-family: inherit;
  text-decoration: none;
  line-height: 1;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.1s ease-out;
  font-size: 1.3rem;
  background-color: #fcbb00;
  border: 0;
  border-radius: 2.3rem;
  padding: 1rem 3rem;
  letter-spacing: 1px;

  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
  }
`;

const Title = styled.span`
  padding-top: 0.25em;
  transition: all 0.1s ease-out;
  color: #222;
`;

const Subtitle = styled.span`
  font-weight: 700;
  margin-top: 0.4rem;
  margin-bottom: 0;
  color: #aeaeae;
  font-size: 1.1rem;
  line-height: 1.3;
`;

export default Link;
